import React, { useState } from 'react';
import './ImageSlider.scss';

const ImageSlider = (props) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(false);

  const goToPrevious = () => {
    setFade(true);
    setTimeout(() => {
      const isFirstSlide = currentIndex === 0;
      const newIndex = isFirstSlide ? props.slidesArr.length - 1 : currentIndex - 1;
      setCurrentIndex(newIndex);
      setFade(false);
    }, 500); // Тайминг совпадает с transition в CSS
  };

  const goToNext = () => {
    setFade(true);
    setTimeout(() => {
      const isLastSlide = currentIndex === props.slidesArr.length - 1;
      const newIndex = isLastSlide ? 0 : currentIndex + 1;
      setCurrentIndex(newIndex);
      setFade(false);
    }, 500); // Тайминг совпадает с transition в CSS
  };

  return (
    <div className="slider">
      <div className="slider-arrow left-arrow" onClick={goToPrevious}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="24"
          viewBox="0 0 28 24"
          fill="none">
          <path
            d="M0.93934 10.9393C0.353553 11.5251 0.353553 12.4749 0.93934 13.0607L10.4853 22.6066C11.0711 23.1924 12.0208 23.1924 12.6066 22.6066C13.1924 22.0208 13.1924 21.0711 12.6066 20.4853L4.12132 12L12.6066 3.51472C13.1924 2.92893 13.1924 1.97919 12.6066 1.3934C12.0208 0.807611 11.0711 0.807611 10.4853 1.3934L0.93934 10.9393ZM26 13.5C26.8284 13.5 27.5 12.8284 27.5 12C27.5 11.1716 26.8284 10.5 26 10.5V13.5ZM2 13.5H26V10.5H2V13.5Z"
            fill="black"
          />
        </svg>
      </div>
      <div className={`slider-content ${fade ? 'fade' : ''}`}>{props.slidesArr[currentIndex]}</div>
      <div className="slider-arrow right-arrow" onClick={goToNext}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="24"
          viewBox="0 0 28 24"
          fill="none">
          <path
            d="M2 10.5C1.17157 10.5 0.5 11.1716 0.5 12C0.5 12.8284 1.17157 13.5 2 13.5V10.5ZM27.0607 13.0607C27.6464 12.4749 27.6464 11.5251 27.0607 10.9393L17.5147 1.3934C16.9289 0.807611 15.9792 0.807611 15.3934 1.3934C14.8076 1.97919 14.8076 2.92893 15.3934 3.51472L23.8787 12L15.3934 20.4853C14.8076 21.0711 14.8076 22.0208 15.3934 22.6066C15.9792 23.1924 16.9289 23.1924 17.5147 22.6066L27.0607 13.0607ZM2 13.5H26V10.5H2V13.5Z"
            fill="black"
          />
        </svg>
      </div>
    </div>
  );
};

export default ImageSlider;
